// extracted by mini-css-extract-plugin
export var videoWrapper = "Video-module--video-wrapper--259Zi";
export var noAccess = "Video-module--no-access--fcJlp";
export var iframe = "Video-module--iframe--3JOKU";
export var title = "Video-module--title--1XFtg";
export var spinAround = "Video-module--spinAround--1KAAM";